import { TableColumn } from 'react-data-table-component';
import { WFAlertHistoryRecord } from 'src/api/wf/models/WfAlertHistory';
import { TFunction } from 'i18next';
import { formatJpnDate } from 'src/common/formatJpnDate/formatJpnDate';

export const getAlertHistoryRecordColumns = (t: TFunction): TableColumn<WFAlertHistoryRecord>[] => [
  {
    name: <div>{t('wf.alertHistoryRecord.buildingCode')}</div>,
    selector: (row) => row.buildingCode,
    sortable: true,
  },
  {
    name: <div>{t('wf.alertHistoryRecord.terminalNumber')}</div>,
    selector: (row) => row.terminalNumber,
    sortable: true,
  },
  {
    name: t('wf.alertHistoryRecord.property1'),
    cell: (row) => row.propertyName1,
    sortable: false,
  },
  {
    name: t('wf.alertHistoryRecord.property2'),
    cell: (row) => row.propertyName2,
    sortable: false,
  },
  {
    name: t('wf.alertHistoryRecord.property3'),
    cell: (row) => row.propertyName3,
    sortable: false,
  },
  {
    name: t('wf.alertHistoryRecord.property4'),
    cell: (row) => row.propertyName4,
    sortable: false,
  },
  {
    name: <div>{t('wf.alertHistoryRecord.alertsReceived')}</div>,
    selector: (row) => row.alertsReceived,
    sortable: true,
    grow: 0.3,
  },
  {
    name: <div>{t('wf.alertHistoryRecord.alertsCompleted')}</div>,
    selector: (row) => row.alertsCompleted,
    sortable: true,
    grow: 0.3,
  },
  {
    name: <div>{t('wf.alertHistoryRecord.lastAlert')}</div>,
    cell: (row) => <span>{formatJpnDate({ iso: row.lastAlertDateTime })}</span>,
    sortable: false,
  },
];
